module.exports = __webpack_public_path__ + "static/media/cal-medical-association-1.edac6ef9.jpg";